export class ConfigHelper {

    public static Version: string = '4.9.7';

    public static Projeto: string = 'INTEROZONE';

    public static Distribuidor: string = 'Interozone';

    public static Url: string = 'https://api.interozone.app/api/';

    public static UrlIntergracao: string = 'https://api.interozone.app/api/';

    public static UrlStorage: string = 'https://integracao.camptecnologia.com.br/';

    public static UrlCheckList: string = 'https://checklist.interozone.app/';

    public static UrlPesquisaV1: string = 'https://api-pesquisa.interozone.app/v1/interozone/';

    public static ApiCheckListV1: string = 'checklist/acampa/v1/';

    public static ApiAnexosV1: string = 'checklist_anexos/acampa/v1/';

    public static Token: string = 'a59e7487cb56a218e6113396e64261981c647603';

    public static TokenDms: string = 'f08Ae54b97c066d0ecSD256f97c0608e54b9ea26d0e54a7RRea2e135';

    public static TokenStorage: string = 'd76e45028a10cfba523b17118f99e2e3';

    public static TokenChecklist: string = '088eceae0ebef44e9b39b83bf1df285f2fd27c9550fc9b319b8df8b3bd5ef25234780156$1$0IM3sqIV$4kfgzIMhpmIXOAgdwDB5W0';

    public static TokenPesquisa: string = 'd76e45028a10cfba523b17118f99e2e3';
    
    public static OneSignalAppId: string = '36249b8c-acc6-4143-97fd-c2370692507f';

    //acampa31
    public static storageKeys = {
        codConcessionaria: 'interozone_23_06.codConcessionaria',
        cnpj: 'interozone_23_06.cnpj',
        cpf: 'interozone_23_06.cpf',
        atualizaautomaticamente: 'interozone_23_06.atualizaautomaticamente',
        precoosagregados: 'interozone_23_06.precoosagregados',
        concessionaria: 'interozone_23_06.concessionaria',
        cardapios1: 'interozone_23_06.cardapios1',
        cardapios2: 'interozone_23_06.cardapios2',
        marcamodelo: 'interozone_23_06.marcamodelo',
        checklistEntrada: 'interozone_23_06.checklistEntrada',
        checklistMecanico: 'interozone_23_06.checklistMecanico',
        checklistSaida: 'interozone_23_06.checklistSaida',
        checklistOrcamento: 'interozone_23_06.checklistOrcamento',
        checklistOficina: 'interozone_23_06.checklistOficina',
        checklistInspecao: 'interozone_23_06.checklistInspecao',
        checklistExtra: 'interozone_23_06.checklistExtra',
        cameraAberta: 'interozone_23_06.cameraAberta',
        ultimaDataLimpaCache: 'interozone_23_06.ultimaDataLimpaCache',
        tiposAnexos: 'interozone_23_06.tiposAnexos'
    }

    public static storageKeysSessions = {
        concessionariasAcesso: 'interozone_23_06.concessionariasAcesso',
        concessionariasStorage: 'interozone_23_06.concessionariasStorage',
        imagensCardapio: 'interozone_23_06.imagensCardapio'
    }
}


// WEBPACK FOOTER //
// ./src/app/helpers/configHelper.ts